import * as tslib_1 from "tslib";
import isUndefined from 'lodash/isUndefined';
import castArray from 'lodash/castArray';
import flatten from 'lodash/flatten';
// this prevents `import pathToRegexp from 'path-to-regexp' from ending up in the
// declaration files so consumers don't need `allowSyntheticDefaultImports`
import pathToRegexp from 'path-to-regexp';
var Route = /** @class */ (function () {
    function Route(path) {
        var config = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            config[_i - 1] = arguments[_i];
        }
        this.path = path;
        Object.assign(this, Route.parseConfig(config));
        Object.assign(this, Route.parsePath(path, this.children.length > 0));
        if (this.children.length > 0 && !this.component) {
            this.component = 'router';
        }
    }
    Route.prototype.matches = function (path) {
        var e_1, _a;
        var matches = this.regexp.exec(path);
        if (matches === null) {
            return false;
        }
        if (this.children.length === 0) {
            return true;
        }
        try {
            for (var _b = tslib_1.__values(this.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var childRoute = _c.value;
                var childPath = '/' + (matches[matches.length - 1] || '');
                if (childRoute.matches(childPath)) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    Route.prototype.parse = function (path) {
        var childPath;
        var pathname = path;
        var params = {};
        var matches = this.regexp.exec(path);
        for (var i = 1, len = matches.length; i < len; ++i) {
            var k = this.keys[i - 1];
            var v = matches[i] || '';
            if (k.name === '__child_path__') {
                childPath = '/' + v;
                pathname = path.replace(new RegExp(childPath + '$'), '');
            }
            else {
                params[k.name] = v;
            }
        }
        return { params: params, pathname: pathname, childPath: childPath };
    };
    Route.usePlugin = function () {
        var fns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fns[_i] = arguments[_i];
        }
        var _a;
        (_a = this.plugins).push.apply(_a, tslib_1.__spread(fns));
        return this;
    };
    Route.parseConfig = function (config) {
        var e_2, _a;
        var transformedConfig = this.runPlugins(config);
        var children = [];
        var middleware = [];
        var component;
        var _loop_1 = function (configEntry) {
            if (typeof configEntry === 'string') {
                component = configEntry;
            }
            else if (typeof configEntry === 'function') {
                middleware.push(configEntry);
            }
            else if (configEntry instanceof Route) {
                children.push(configEntry);
            }
            else {
                children.push.apply(children, tslib_1.__spread(Object.keys(configEntry)
                    .map(function (childPath) { return new (Route.bind.apply(Route, tslib_1.__spread([void 0, childPath], castArray(configEntry[childPath]))))(); })));
            }
        };
        try {
            for (var transformedConfig_1 = tslib_1.__values(transformedConfig), transformedConfig_1_1 = transformedConfig_1.next(); !transformedConfig_1_1.done; transformedConfig_1_1 = transformedConfig_1.next()) {
                var configEntry = transformedConfig_1_1.value;
                _loop_1(configEntry);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (transformedConfig_1_1 && !transformedConfig_1_1.done && (_a = transformedConfig_1.return)) _a.call(transformedConfig_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return { component: component, middleware: middleware, children: children };
    };
    Route.runPlugins = function (config) {
        return config.reduce(function (routeStack, configEntry) {
            var configViaPlugins = Route.plugins.reduce(function (allPluginsStack, plugin) {
                var pluginStack = plugin(configEntry);
                return isUndefined(pluginStack)
                    ? allPluginsStack
                    : tslib_1.__spread(allPluginsStack, flatten(castArray(pluginStack)));
            }, []);
            return tslib_1.__spread(routeStack, (configViaPlugins.length > 0
                ? configViaPlugins
                : flatten(castArray(configEntry))));
        }, []);
    };
    Route.parsePath = function (path, hasChildren) {
        if (hasChildren) {
            path = path.replace(/\/?!?$/, '/!');
        }
        if (path[path.length - 1] === '!') {
            path = path.replace('!', ':__child_path__(.*)?');
        }
        else {
            path = path.replace(/\(?\*\)?/, '(.*)');
        }
        var keys = [];
        var regexp = pathToRegexp(path, keys);
        return { keys: keys, regexp: regexp };
    };
    Route.plugins = [];
    return Route;
}());
export { Route };
//# sourceMappingURL=route.js.map